import React from 'react'
import PropTypes from 'prop-types'
import { flowRight } from 'lodash'
import { useTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import { urlWithLangParam } from 'lib/helpers'

import Link from 'components/Link'

const MakeOfferDealerAdNotification = ({ adUrl }) => {
    const { t, i18n } = useTranslation(['makeOffer'])

    return (
        <div className="make-offer-dealer-ad-notification">
            <p>
                {t('makeOffer:dealerAdNotification.description')}
            </p>
            <div className="make-offer-dealer-ad-notification__actions">
                <Link to={urlWithLangParam(adUrl, i18n.language)} className="button button--centered" trackName="showAd">
                    {t('makeOffer:dealerAdNotification.showAd')}
                </Link>
            </div>
        </div>
    )
}

MakeOfferDealerAdNotification.propTypes = {
    adUrl: PropTypes.string.isRequired,
}

export default flowRight(
    withRouter,
)(MakeOfferDealerAdNotification)
